import useDrawerContext from "@contexts/drawerContext"
import useYesOrNo from '@hooks/useYesOrNo'
import { size } from '@styles/theme'

import { DrawerButtonGroup, DrawerContents } from './elements/DrawerLayout'
import { ReportUser } from './elements/bottom_actions/ReportUser'
import { DrawerAvatarGroup } from './elements/DrawerAvatarGroup'
import { DrawerDisplayName } from './elements/DrawerDisplayName'
import { DrawerJoinedText } from './elements/DrawerJoinedText'
import { Toast } from '@base-ui/react'
import {
  NearbyProfileButton,
  SocialProfileButton,
  DrawerCloseButton,
  ReportButton,
  // BlockButton,
} from './elements/DrawerButtons'

const ProfileBottomDrawerContents = ({ otherUser, isOnNearbyProfile=false, isOnSocialProfile=false, }) => {
  // const [isBlockDialogOpen, openBlockDialog, closeBlockDialog] = useYesOrNo('user-actions__block-user')
  const [isReportModalOpen, openReportModal, closeReportModal] = useYesOrNo('profile__report-user')
  const { closeBottomDrawer } = useDrawerContext()
  const toastManager = Toast.useToastManager()

  const handleReportPromise = (promise) => {
    promise?.then?.(() => {
      closeBottomDrawer()
    })
  }

  // const handleBlockPromise = (promise) => {
  //   promise?.then?.(() => {
  //     closeBottomDrawer()
  //     navigate(-1)
  //   })
  // }

  return (
    <DrawerContents>
      {/* <BlockUser
        isOpen={isBlockDialogOpen}
        setClosed={closeBlockDialog}
        handlePromise={handleBlockPromise}
        otherUser={otherUser}
      /> */}
      <ReportUser
        isOpen={isReportModalOpen}
        setClosed={closeReportModal}
        handlePromise={handleReportPromise}
        reportedUser={otherUser}
        reportedItem={otherUser}
        reportedType='User'
      />
      <DrawerCloseButton
        setClosed={closeBottomDrawer}
        style={{ marginLeft: size(3) }}
      />
      <DrawerAvatarGroup user={otherUser} />
      <DrawerDisplayName user={otherUser} />
      <DrawerJoinedText
        user={otherUser}
        style={{ marginLeft: size(5) }}
      />
      <DrawerButtonGroup style={{ paddingTop: size(1) }}>
        {otherUser?.nearbyUuid &&
          <NearbyProfileButton
            isOnNearbyProfile={isOnNearbyProfile}
            user={otherUser}
          />
        }
        {!otherUser?.isAnonymous &&
          <SocialProfileButton
            isOnSocialProfile={isOnSocialProfile}
            user={otherUser}
          />
        }
        <ReportButton onClick={openReportModal} />
      </DrawerButtonGroup>
      {/* <DrawerButtonGroup>
        <BlockButton
          onClick={openBlockDialog}
        />
        <ReportButton />
      </DrawerButtonGroup> */}
    </DrawerContents>
  )
}

export { ProfileBottomDrawerContents }
